import { Directive, HostBinding, Input } from '@angular/core';
import { NgModel } from '@angular/forms';
import { TitleProps, titleStyles } from '@kite_aerolab/shared/components';

@Directive({
  selector: '[kiteTitle]',
  providers: [NgModel],
})
export class TitleDirective {
  /**
   * Tamaño del título: medium, large, extra large o extra extra large
   */
  @Input() size: TitleProps['size'];

  /**
   * Alineación del texto en el título
   */
  @Input() align: TitleProps['align'];

  /**
   * Css del componente
   */
  @Input() css: TitleProps['css'];

  @HostBinding('class')
  public get setClasses() {
    return titleStyles({
      size: this.size,
      align: this.align,
      css: this.css,
    }).className;
  }
}
